<template>
  <div class="moduleContainer">
    <div class="header">
      <div class="title">
        <i class="el-icon-s-order"></i>
        询报价统计
      </div>
      <div>
        <!-- class="operations" -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-select v-model="SearchData.module" placeholder="请选择模块" size="small" clearable
              @change="GetTableList(true)" @clear="GetTableList(true)">
              <el-option v-for="item in moduleList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-input placeholder="请输入用户手机号" size="small" v-model="SearchData.phone" clearable
              @clear="GetTableList(true)" @keyup.enter.native="GetTableList(true)">
            </el-input>
          </el-col>
          <el-col :span="8">
            <el-select v-model="SearchData.tenant_id" filterable clearable remote reserve-keyword
              placeholder="输入企业名进行筛选" size="small" :remote-method="remoteMethod" @change="GetTableList(true)">
              <el-option v-for="item in tenant_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px">
          <el-col :span="12">
            <el-date-picker v-model="SearchData.dateRange" size="small" type="daterange" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="GetTableList(true)">
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <el-select style="margin-left: 10px" v-model="SearchData.manager_id" clearable placeholder="根据业务员筛选"
              size="small" @change="GetTableList(true)">
              <el-option v-for="manager of managerList" :key="manager.id" :label="manager.display_name"
                :value="manager.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-input-number v-model="SearchData.duplicate_target_business" @change="GetTableList(true)" :min="1" size="small"></el-input-number>
          </el-col>
          
        </el-row>
      </div>
    </div>
    <div class="businessList">
      <el-table :data="TableList" :stripe="false" :row-class-name="tableRowClassName"
        @selection-change="HandleSelectionChange" @sort-change="HandleSortChange" style="box-shadow: none">
        <el-table-column label="企业" width="200">
          <el-table-column label="用户" width="200">
            <template slot-scope="scope">
              <div>
                <template v-if="scope.row.tenant">
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">{{ scope.row.tenant.name }}</div>
                    <div class="one_lines">{{ scope.row.tenant.name }}</div>
                  </el-tooltip>
                </template>
                <template v-else-if="scope.row.user && scope.row.user.pre_company_name">
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">{{ scope.row.user.pre_company_name }}</div>
                    <div class="one_lines" style="color: #ccc">{{ scope.row.user.pre_company_name }}</div>
                  </el-tooltip>
                </template>
                <template v-else> - </template>
              </div>
              <div>
                <template v-if="scope.row.user">
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">
                      {{ scope.row.user.display_name }}
                      {{ scope.row.user.mobile }}
                    </div>
                    <div class="one_lines">
                      {{ scope.row.user.display_name }}
                      {{ scope.row.user.mobile }}
                    </div>
                  </el-tooltip>
                </template>
                <template v-else> - </template>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="询/报价目标" prop="business_code" sortable="custom">
          <el-table-column label="询/报价详情">
            <template slot-scope="scope">
              <div>
                【{{ $utils.listFilter(business_moduleList, scope.row.business_module) }}】
                <span :class="{ ViewLink: transformTarget(scope.row) }" @click="goTransformTarget(scope.row)">
                  {{ scope.row.business_code }}
                  {{ scope.row.info.title }}
                </span>
              </div>

              <div>
                <template v-if="scope.row.price">
                  价格：{{ scope.row.price }}
                </template>
                <template v-if="scope.row.amount">
                  数量：{{ scope.row.amount }}
                </template>
                {{ scope.row.extra_params }}
              </div>

              <div v-if="scope.row.img_array">
                <el-image
                  style="width:50px;height:50px;margin-right:5px;"
                  v-for="item of scope.row.img_array"
                  :key="item"
                  :src="item"
                  fit="contain"
                  :preview-src-list="scope.row.img_array"
                ></el-image>
              </div>

            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="时间" width="150" prop="created_time" sortable="custom">
          <el-table-column label="来源业务员" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.created_time.slice(0, 16) }}</div>
              <div v-if="scope.row.user">
                <!-- 报价 -->
                <template v-if="scope.row.module == 'purchase'">
                  {{ $utils.listFilter(managerList, scope.row.user.manager_caigou_id, "display_name") }}
                </template>
                <!-- 询价 -->
                <template v-else-if="scope.row.module == 'quotation'">
                  {{ $utils.listFilter(managerList, scope.row.user.manager_shichang_id, "display_name") }}
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-pagination v-if="TotalCount" style="margin-top: 30px; justify-content: center" background
        @size-change="HandleSizeChange" @current-change="HandleCurrentChange" :current-page="CurrentPage"
        :page-sizes="PageSizeList" :page-size="PageSize" layout="total, prev, pager, next, jumper"
        :total="TotalCount"></el-pagination>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
export default {
  name: "MessageList",
  mixins: [tableMixin],
  props:{
    managerList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      SearchData: {
        module: this.$localStorage.get("admin_message_module")
          ? this.$localStorage.get("admin_message_module").split(",")
          : [],
        tenant_id: "",
        manager_id: "",
        phone: "",
        dateRange: null,
        duplicate_target_business: 1,//用于筛选多次涉及的内容
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      ScrollAfterChange: false,
      moduleList: [
        {
          name: "报价",
          id: "purchase",
        },
        {
          name: "询价",
          id: "quotation",
        },
        {
          name: "拼单",
          id: "raise",
        },
      ],
      business_moduleList: [
        {
          name: "拼单",
          id: "business_raise",
        },
        {
          name: "现货卖场",
          id: "business_quotation",
        },
        {
          name: "锻件定制",
          id: "business_purchase_forging",
        },
        {
          name: "原料求购",
          id: "business_purchase_material",
        },
        {
          name: "零切求购",
          id: "business_purchase_piece",
        },
      ],
      tenant_list: [],
    };
  },
  created() {
    this.remoteMethod();
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      let requestParams = {
        ...this.SearchData,
        ordering: this.Sorting,
        size: this.PageSize,
        page: this.CurrentPage,
      };
      if (this.SearchData.dateRange) {
        requestParams.start_time = this.SearchData.dateRange[0];
        requestParams.end_time = this.SearchData.dateRange[1];
      }
      this.axios
        .get("/api/admin_business_action/", {
          params: requestParams,
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map(row=>{
            try {
              row.img_array = JSON.parse(row.img_array)
            } catch (error) {
              // console.log(error)
            }
            return row
          });
        });
    },
    tableRowClassName({ row }) {
      if (row.is_top) {
        return "is_top";
      } else if (row.is_read) {
        return "is_read";
      }
      return "";
    },
    remoteMethod(query) {
      this.axios
        .get("/api/admin_tenant/simple_list/", {
          params: {
            name: query,
            size: 20,
          },
        })
        .then((data) => {
          this.tenant_list = data.results;
        });
    },
    transformTarget(row) {
      var target_module = row.business_module;
      var business_code = row.business_code;//目标code
      // var code = row.code;//business的code

      if (target_module == "business_quotation") {
        return "/admin/quotation?code=" + business_code;
      } else if (target_module == "business_purchase_forging") {
        return "/admin/purchase_forging?code=" + business_code;
      } else if (target_module == "business_purchase_material") {
        return "/admin/purchase_material?code=" + business_code;
      } else if (target_module == "business_purchase_piece") {
        return "/admin/purchase_piece?code=" + business_code;
      }
      return false;
    },
    goTransformTarget(row) {
      var target = this.transformTarget(row);
      if (target) {
        this.$openRouter(target);
      }
    },
  },
};
</script>


<style scoped lang="scss">
.moduleContainer {
  width: 100%;
  background: #fff;
  margin-top: 15px;
  padding-bottom: 20px;

  .header {
    padding: 18px 0;
    margin: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    border-bottom: 1px solid $borderPlainColor;

    .title {
      flex-shrink: 0;

      i {
        margin-right: 4px;
        color: $warningColor;
        font-size: 18px;
      }
    }

    .operations {
      display: flex;
      align-items: center;
      flex-grow: 1;
      margin-left: 50px;
    }
  }
}

.businessList {
  font-size: 12px;
  padding: 0 20px;

  .businessItem {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 15px;

    .date {
      flex-shrink: 0;
      width: 120px;
      color: #999;
      text-align: right;
    }
  }
}
</style>
